import { render, staticRenderFns } from "./formRtoken.vue?vue&type=template&id=3a71c908&scoped=true"
import script from "./formRtoken.vue?vue&type=script&lang=js"
export * from "./formRtoken.vue?vue&type=script&lang=js"
import style0 from "./formRtoken.vue?vue&type=style&index=0&id=3a71c908&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a71c908",
  null
  
)

export default component.exports